module.exports = __webpack_public_path__ + "839c011cc735856c6c5f3a97bded53e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/aut.svg
// module id = 142
// module chunks = 0